import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

import { FormControl, FormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { InstallationFeaturesStore, ReplaceGatewayFormGroup } from '@store';
import { isEqual } from 'lodash';

@Component({
  selector: 'app-replace-gateway-modal',
  templateUrl: './replace-gateway-modal.component.html',
  styleUrls: ['./replace-gateway-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReplaceGatewayModalComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  replaceGatewayFormGroup: FormGroup<ReplaceGatewayFormGroup>;
  constructor(
    private dialogRef: MatDialogRef<ReplaceGatewayModalComponent>,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.installationFeaturesStore.setFormReplaceGateway({
      oldGatewaySerial: null,
      oldGatewayPassword: null,
      newGatewaySerial: null,
      newGatewayPassword: null,
    });

    this.replaceGatewayFormGroup = new FormGroup<ReplaceGatewayFormGroup>({
      oldGatewaySerial: new FormControl<string>(null, [Validators.required]),
      oldGatewayPassword: new FormControl<string>(null, [Validators.required]),
      newGatewaySerial: new FormControl<string>(null, [Validators.required]),
      newGatewayPassword: new FormControl<string>(null, [Validators.required]),
    });

    this.replaceGatewayFormGroup.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged(isEqual), takeUntil(this.ngUnsubscribe$))
      .subscribe((value) => {
        this.installationFeaturesStore.setFormReplaceGateway({
          oldGatewaySerial: value.oldGatewaySerial,
          oldGatewayPassword: value.oldGatewayPassword,
          newGatewaySerial: value.newGatewaySerial,
          newGatewayPassword: value.newGatewayPassword,
        });
      });
  }

  onConfirm(): void {
    this.installationFeaturesStore.updateReplaceGateway();
    this.dialogRef.close();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
